"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSecurityEnabled = exports.isAutoExpiryEnabled = exports.extractTemplateDataFromProjectForTemplateLibrary = void 0;
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
function isAutoExpiryEnabled(projectLink) {
    var _a;
    if ((0, isEmpty_1.default)(projectLink))
        return undefined;
    return (_a = projectLink.autoLinkExpiry) === null || _a === void 0 ? void 0 : _a.enabled;
}
exports.isAutoExpiryEnabled = isAutoExpiryEnabled;
function isSecurityEnabled(projectLink) {
    var _a;
    if ((0, isEmpty_1.default)(projectLink))
        return undefined;
    return projectLink.isPasswordProtected || ((_a = projectLink.identityMapping) === null || _a === void 0 ? void 0 : _a.enabled);
}
exports.isSecurityEnabled = isSecurityEnabled;
var extractTemplateDataFromProjectForTemplateLibrary = function (project) {
    return {
        name: project.name,
        secret: project.links[0].secret,
        projectId: project._id,
        $userAction: project.$userAction,
        crmInfo: project.crmInfo,
        isAccountTemplate: true,
        isAutoExpiryEnabled: isAutoExpiryEnabled(project.links[0]),
        isSecurityEnabled: isSecurityEnabled(project.links[0]),
        category: "My Templates",
        categories: [],
    };
};
exports.extractTemplateDataFromProjectForTemplateLibrary = extractTemplateDataFromProjectForTemplateLibrary;
